
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["compile"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "94fea772ca4fbc904a68.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "94fea772ca4fbc904a68.worker.js");
					addMethods(w, methods)
					
					return w
				}
			